var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgRowConnector = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 48,
    viewBox: "0 0 8 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4 0L4 24",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4 24L4 48",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58008 23.6611H7.35547V24.8574H4.58008V28.002H3.30859V24.8574H0.533203V23.6611H3.30859V20.7559H4.58008V23.6611Z",
    fill: "#808080"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgRowConnector);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/row-connector.c8f8d420d03413cd254b8cba3c0f1c0f.svg";